import axios from 'axios';
import {useCallback, useEffect, useState} from 'react' //eslint-disable-line
import { useDispatch } from 'react-redux';
import { UserActions } from 'src/pages/User/store/reducer';

export function useGetPermissions(){
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const handlePermissions = useCallback(async () => {
    dispatch(UserActions.initLoading());
    try{

      const config = {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      }
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/auth/me`, config);
      dispatch(UserActions.asyncPermissions(response?.data?.roles));
      dispatch(UserActions.asyncUser(response?.data));
      dispatch(UserActions.endLoading());
      return null;
    } catch(error){
      console.log(error)
      dispatch(UserActions.endLoading());
    }
  }, [])

  return handlePermissions
}